import { makeAutoObservable } from 'mobx';
import { token } from '@/infrastructure/container';

// The screens the console can show. Admin screens require the `admin` role (gated in AppView); `account` is
// available to any signed-in user.
export type Screen = 'users' | 'clients' | 'events' | 'account';

/** A tiny in-app router: the current screen. No routing library (INVARIANTS), a single observable. */
export class NavStore {
  private _screen: Screen = 'users';

  constructor() {
    makeAutoObservable(this);
  }

  get screen(): Screen {
    return this._screen;
  }

  go(screen: Screen): void {
    this._screen = screen;
  }
}

export const TOKEN_NavStore = token<NavStore>('NavStore');
